import React from "react";
import HackLeaderboard from "../components/hacks/HackLeaderboard";
import HackLayout from "../components/hacks/HackLayout";

const HackLeaderboardPage = () => {
  return (
    <HackLayout activeId="4">
      <HackLeaderboard />
    </HackLayout>
  );
};

export default HackLeaderboardPage;
